<template>
  <v-card
    class="product-card rounded-lg px-0 px-md-2 d-flex flex-column w-100"
    v-bind="$attrs"
    v-on="$listeners"
    color="sand"
    :ripple="{ class: `primary--text` }"
    :style="myStyles"
    :elevation="0"
    @click="emitProductId"
  >
    <v-card-title
      class="text-title text-capitalize primary--text font-weight-bold pt-5 pb-1 d-flex flex-row justify-start justify-md-start"
    >
      {{ title.toLowerCase() }}
    </v-card-title>
    <v-card-text
      v-if="$vuetify.breakpoint.mdAndUp"
      class="pt-1 d-flex flex-column justify-start justify-space-between card_text"
    >
      <v-row dense class="d-flex flex-row justify-space-between">
        <v-col
          v-for="(g, i) in generals"
          :key="i"
          cols="1"
          class="d-flex flex-column justify-center"
          :class="{ 'text-right': i > 0 }"
        >
          <span class="text-label font-weight-bold primary--text">
            {{ g.label.data }}
          </span>
        </v-col>
      </v-row>
      <v-row dense class="d-flex flex-row justify-space-between">
        <v-col
          v-for="(g, i) in generals"
          :key="i"
          cols="1"
          class="d-flex flex-column justify-center"
          :class="{ 'text-right': i > 0 }"
        >
          <span
            class="text-currency text-body-1 font-weight-medium"
            :class="parseInt(g.value.data, 10) >= 0 ? 'primary--text' : 'error--text'"
          >
            {{ g.value.data }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text
      v-else
      class="pt-1 d-flex flex-column justify-start justify-space-between card_text"
    >
      <v-row v-for="g in generals" :key="g.index" dense>
        <v-col cols="6" class="d-flex flex-column justify-center">
          <span class="text-label font-weight-medium primary--text">
            {{ g.label.data }}
          </span>
        </v-col>
        <v-col cols="6" class="text-right d-flex flex-column justify-center">
          <span
            class="text-currency font-weight-medium primary--text"
            :class="parseFloat(g.value.data) >= 0 ? '' : 'error--text'"
          >
            {{ g.value.data }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    generals: {
      type: [Array, Object],
      default: null
    },
    productReferenced: {
      type: [Array, Object, Number],
      default: null
    }
  },
  methods: {
    emitProductId() {
      this.$emit('emitProductId', this.productReferenced.id)
    }
  },
  computed: {
    myStyles() {
      return this.$vuetify.breakpoint.mdAndUp ? 'height: 200px' : 'height: 265px'
    }
  }
}
</script>

<style lang="sass" scoped>
.product-card
  width: 100%
  height: 250px

  &.v-card--link::before
    background: white

  .text-title
    font-size: 1.35rem

  .text-label
    font-size: 12px

  .text-currency
    font-size: 12px

  .card_text
    min-height: 60%
